// extracted by mini-css-extract-plugin
module.exports = {"bootstrap-table":"style_bootstrap-table__31ZhF"};